import React from 'react';

import { BaseComparissonBarChart } from '../Common/ComparissonBarChart';
import { JsonPropsType } from '../../../component-loader';
import { GenericTableRawData } from './types';
import { formatData } from '../../../utils/deck';
import { ResponsiveWrapper } from '../Common/ResponsiveWrapper';

type ExpectedColumns = {
  IPSA: number;
  Portafolio: number;
  Activo: number;
};

type FormattedChartData = ExpectedColumns & {
  name: string;
};

const MARGINS = {
  bottom: 0,
  left: 10,
  right: 0,
  top: 0,
};
// This kind of chart needs to be formatted as an array of objects
function transformDataToArray(data: { [key: string]: ExpectedColumns }) {
  const chartData = Object.entries(data).map(([key, value]) => ({
    name: key,
    ...value,
  }));
  return chartData;
}

export function PortfolioMetricsBarChart(props: JsonPropsType) {
  const rawData = props.jsonObject as GenericTableRawData;
  // All the columns are expected to be percentages, but they are received as decimals
  // So, we don't add any parsing exceptions
  const formattedData = formatData<{ [key:string]: ExpectedColumns }>({ rawData });
  const arrayOfData = transformDataToArray(formattedData);
  return (
    <ResponsiveWrapper minHeight={850}>
      <BaseComparissonBarChart<FormattedChartData>
        data={arrayOfData}
        layout="vertical"
        mainAxisDataKey="name"
        margin={MARGINS}
        dataKeys={['Portafolio', 'IPSA']}
        yAxisDomain={['dataMin', 'dataMax + 10']}
        legendLabels={{ IPSA: 'IPSA', Portafolio: 'Portafolio' }}
        yAxisUnit="%"
      />
    </ResponsiveWrapper>
  );
}
